export const LOAD_TRANSACTION = "LOAD_TRANSACTION";
export const GET_ALL_TRANSACTION = "GET_ALL_TRANSACTION";
export const ERROR_TRANSACTION = "ERROR_TRANSACTION";
